import styles from '../Styles/account.module.scss';
import React, {useContext, useEffect, useRef, useState} from 'react';
import { useTranslation } from 'react-i18next';
import { FiCheckCircle, FiEdit2, FiGrid, FiUser, FiX, FiXOctagon, FiMail, FiFolder } from 'react-icons/fi';
import { useForm } from 'react-hook-form';
import { AnimatePresence, motion } from 'framer-motion';
import cx from 'classnames';

import { updateMyAccount } from '../services/accountService';
import Swal from 'sweetalert2';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { MyPerformanceTaskContainer } from './MyPerformance';
import SideModal from './SideModal';
import { TaskModal } from './Overview';
import Modal from './Modal';
import {UserContext} from "../Contexts/UserContext";
import { getMineProjects } from '../services/projectService';
import { getUserTaskStats } from '../services/accountService'; 


const tasksTest = [
  { id: 1, task: 'Rédiger une proposition de projet', assignedTo: 'Adil Stifi', dueDate: '08/01/2024', status: "Pas commencé", priority: "Hight", subTasks: [] },
  { id: 2, task: 'Planifier la réunion de lancement', assignedTo: 'Adil Stifi', dueDate: '03/01/2024', status: "En cours", priority: "Medium", subTasks: [] },
  { id: 3, task: 'Rédiger une proposition de projet', assignedTo: 'Adil Stifi', dueDate: '08/01/2024', status: "Pas commencé", priority: "Hight", subTasks: [] },
  { id: 4, task: 'Planifier la réunion de lancement', assignedTo: 'Adil Stifi', dueDate: '03/01/2024', status: "En cours", priority: "Medium", subTasks: [] },
];

function EditModal(){

  const {user} = useContext(UserContext);
  const { register, handleSubmit, watch, setValue, formState: { errors } } = useForm();
  const { t } = useTranslation();
  const [isEmailValide, setIsEmailValide] = useState(false);

  const [loading, setLoading] = useState(false);
  const [errorCode, setErrorCode] = useState("");
  const [userCreated, setUserCreated] = useState(false);
  const [isEditPassword, setIsEditPassword] = useState(false);

  const onSubmit = async (data) => {
    setLoading(true);
    const userData = {
      email: user.email,
      firstName: data.firstName,
      lastName: data.lastName,
      enabled: true,
      ...(isEditPassword && data.password ? { password: data.password } : {}),
      role: data.role
    };
    const formData = new FormData();
    formData.append('userDto', new Blob([JSON.stringify(userData)], { type: 'application/json' }));
  
    try {
      await updateMyAccount(formData);
      toast.success(t('USERS.MODAL.USER_UPDATED_MSG'));
      // Optionally: closeEditModal();
    } catch (error) {
      toast.error(t('USERS.MODAL.USER_UPDATE_ERROR_MSG') + ': ' + (error.message || ''));
    } finally {
      setLoading(false);
    }
  };



  if(userCreated){
    return(
      <div className='min-w-[35vw] flex flex-col items-center justify-center gap-5' >
        <FiCheckCircle size={84} className='text-green-700 ' />
        <h1 className='text-center text-xl font-semibold mb-2' >{t("USERS.MODAL.USER_CREATED_MSG")}</h1>
      </div>
    )
  }

  return(
    <div className='max-w-[45vw] min-w-[35vw]' >
      { errorCode.length > 0 && <p className='text-sm font-semibold text-[#D6323A] mb-5' >{t(`ERRORS.${errorCode}`)}</p>}
      <form onSubmit={handleSubmit(onSubmit)} className='flex flex-col w-full' >
        <div className='flex items-center justify-between gap-3 mb-3' >
          <div className='flex flex-col w-full' >
            <div className='px-2.5 mb-0.5 flex items-center justify-between' >
              <label className='text-xs text-gray-500 font-semibold' >{t("USERS.MODAL.LAST_NAME")} *</label>
              { errors.lastName && <label className='text-xs text-red-700 font-semibold' >{t("COMMON.REQUIRED_ERROR")}</label>}
            </div>
            <input
              className='border rounded-lg px-2 py-1.5 text-sm'
              placeholder={t("USERS.MODAL.LAST_NAME")}
              {...register("lastName", { required: true })}
              defaultValue={user.lastName}
            />
          </div>
          <div className='flex flex-col w-full' >
            <div className='px-2.5 mb-0.5 flex items-center justify-between' >
              <label className='text-xs text-gray-500 font-semibold' >{t("USERS.MODAL.FIRST_NAME")} *</label>
              { errors.firstName && <label className='text-xs text-red-500 font-semibold truncate max-w-[40%]' >{t("COMMON.REQUIRED_ERROR")}</label>}
            </div>
            <input
              className='border rounded-lg px-2 py-1.5 text-sm'
              placeholder={t("USERS.MODAL.FIRST_NAME")}
              {...register("firstName", { required: true })}
              defaultValue={user.firstName}
            />
          </div>
        </div>
        <div className='flex flex-col w-full mb-3' >
          <div className='px-2.5 mb-0.5 flex items-center justify-between' >
            <label className='text-xs text-gray-500 font-semibold' >{t("USERS.MODAL.ROLE")} *</label>
            { errors.role && <label className='text-xs text-red-500 font-semibold' >{t("COMMON.REQUIRED_ERROR")}</label>}
          </div>
          <input
            className='border rounded-lg px-2 py-1.5 text-sm'
            placeholder={t("USERS.MODAL.ROLE")}
            {...register("role", { required: true })}
            defaultValue={user.roles && user.roles[0] && user.roles[0].name}
          />
        </div>
        <div className='border p-2 rounded-lg' >
          <div className='flex items-center justify-between' >
            <p className='text-gray-500 text-sm font-semibold' >{t("USERS.MODAL.PASSWORD")}</p>
            <div className='border rounded-full p-1 cursor-pointer' onClick={()=> setIsEditPassword(!isEditPassword) } >
              <FiX className={cx('transition duration-300', {'rotate-0': isEditPassword, 'rotate-45': !isEditPassword})} />
            </div>
          </div>
          <motion.div
            initial="closed"
            animate={isEditPassword ? "open" : "closed"}
            variants={{
              open: { opacity: 1, height: 'auto' },
              closed: { opacity: 0, height: 0 }
            }}
            transition={{ duration: 0.5 }}
            className={cx('flex flex-col', {'mt-3': isEditPassword})}
          >
            <div className='px-2.5 mb-0.5 flex items-center justify-between' >
              <label onClick={()=> console.log(errors.password) } className='text-xs text-gray-500 font-semibold' >{t("USERS.MODAL.PASSWORD")}</label>
              { errors.password && <label className='text-xs text-red-500 font-semibold' >{t("COMMON.REQUIRED_ERROR")}</label>}
            </div>
            <input
              className='border rounded-lg px-2 py-1.5 text-sm'
              placeholder={t("USERS.MODAL.PASSWORD")}
              // {...register("password", { required: false })}
              {...register("password", {
                required: isEditPassword ? "required" : false,
                minLength: {
                  value: 8,
                  message: "Le mot de passe doit contenir au moins 8 caractères"
                },
                maxLength: {
                  value: 16,
                  message: "Le mot de passe ne doit pas dépasser 16 caractères"
                },
                pattern: {
                  value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,16}$/,
                  message: "Le mot de passe doit contenir au moins un chiffre, une majuscule, une minuscule et un caractère spécial"
                }
              })}
            />
            <div className='px-3.5' >
              <p className='text-xs text-gray-500' >{errors.password ? errors.password.message !== "required" && errors.password.message : null }</p>
            </div>
          </motion.div>
        </div>
        <div className='flex justify-end mt-6' >
          {
            loading ?
            <div className='border border-azure rounded-lg h-9 w-32 relative' >
              <div className='loader'/>
            </div>
            :
            <input
              type="submit"
              value={t("COMMON.SAVE")}
              className='border border-azure font-semibold cursor-pointer rounded-lg px-4 py-1.5 text-sm text-azure hover:text-white hover:bg-purple-light'
            />
          }
        </div>
      </form>
    </div>
  )
}

export default function Account() {

  const {user} = useContext(UserContext);
  const {t} = useTranslation();

  const profileRef = useRef(null);
  const savedRef = useRef(null);

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isTaskModalOpen, setIsTaskModalOpen] = useState(false);
  const [currTab, setCurrTab] = useState("profile");
  const [taskData, setTaskData] = useState({});
  const statsConfig = [
    { id: 1, title: "Total des projets", key: "totalProjects", color: "#2a2a66" },
    { id: 2, title: "Total des tâches", key: "totalTasks", color: "#" },
    { id: 3, title: "Tâches terminées", key: "totalFinishedTasks", color: "#23B301" },
    { id: 4, title: "Tâches en cours", key: "totalInProgressTasks", color: "#7878c7" },
    { id: 5, title: "Tâches retardées", key: "totalLateTasks", color: "#D6323A" },
  ];
  const [userStats, setUserStats] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const stats = await getUserTaskStats(user.id);
        setUserStats(stats);
      } catch (error) {
        console.error("Failed to fetch user stats:", error); 
      }
    };
    if (user?.id) {
      fetchStats();
    }
  }, [user?.id]);

  const [userProjects, setUserProjects] = useState([]);
  const [userTasks, setUserTasks] = useState([]);
  const [loadingTasks, setLoadingTasks] = useState(false);

  useEffect(() => {
    const fetchUserProjectsAndTasks = async () => {
      setLoadingTasks(true);
      try {
        const projects = await getMineProjects();
        setUserProjects(projects); 
        const tasks = projects.flatMap(project => project.tasks || []);
        setUserTasks(tasks);
      } catch (err) {
        toast.error(t('Erreur lors du chargement des tâches utilisateur'));
      } finally {
        setLoadingTasks(false);
      }
    };
    fetchUserProjectsAndTasks();
  }, []);

  const openEditModal = (task)=>{
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    setIsEditModalOpen(true);
  }
  const closeEditModal = ()=>{
    document.getElementsByTagName('body')[0].style.overflow = 'auto';
    setIsEditModalOpen(false);
  }

  const openTaskModal = (task)=>{
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    setIsTaskModalOpen(true);
    setTaskData(task);
  }
  const closeTaskModal = ()=>{
    document.getElementsByTagName('body')[0].style.overflow = 'auto';
    setIsTaskModalOpen(false);
    setTaskData({});
  }
  useEffect(() => {
    if (currTab === "profile" && profileRef.current) {
      profileRef.current.scrollIntoView({ behavior: 'smooth' });
    } else if (currTab === "saved" && savedRef.current) {
      savedRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [currTab]);

  return (
    <div className='mt-6' >
      <div className='rounded-lg flex gap-2 items-center justify-between mb-4' >
        {/* Avatar and Name */}
        <div className="flex items-center gap-4 mb-2">
          <div className="w-14 h-14 bg-blue-100 text-blue-700 flex items-center justify-center rounded-full text-2xl font-bold">
            {user.firstName?.[0]}
            {user.lastName?.[0]}
          </div>
          <div>
            <h2 className="font-bold text-xl mb-1">{user.firstName} {user.lastName}</h2>
            <h4 className="font-semibold text-sm text-gray-500">{user.username}</h4>
          </div>
        </div>
        <div className='grid grid-cols-5 gap-3 w-[70%]'>
          {statsConfig.map((it) =>
            <div key={it.id} className='flex flex-col justify-between'>
              <p className='text-sm text-gray-400 font-semibold mb-1'>{it.title}</p>
              <div className='text-2xl font-semibold border-l-2 pl-2' style={{borderColor: it.color}}>
                {userStats ? userStats[it.key] : '...'}
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="border-b border-gray-200 dark:border-gray-700 mb-4">
        <ul className="flex flex-wrap -mb-px text-sm font-medium text-center text-gray-400">
          <li className="me-2">
            <button onClick={()=> setCurrTab("profile") } className={cx("inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 group", {'border-b-purple-light text-purple-light hover:border-b-purple-dark hover:text-purple-dark': currTab === "profile" })}>
              <div className={cx("w-4 h-4 me-2 group-hover:text-gray-500 dark:text-gray-500", {'group-hover:text-purple-dark': currTab === "profile"})} >
                <FiUser size={17} />
              </div>
              {t("ACCOUNT.INFORMATIONS_TITLE")}
            </button>
          </li>
          <li className="me-2">
            <button onClick={()=> setCurrTab("saved") } className={cx("inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 group", {'border-b-purple-light text-purple-light hover:border-b-purple-dark hover:text-purple-dark': currTab === "saved" })}>
              <div className={cx("w-4 h-4 me-2 group-hover:text-gray-500 dark:text-gray-500", {'group-hover:text-purple-dark': currTab === "saved"})} >
                <FiGrid size={17} />
              </div>
              {t("ACCOUNT.SAVED_TASKS")}
            </button>
          </li>
        </ul>
      </div>
      <div className='w-full flex overflow-x-hidden flex-nowrap' >
        <div ref={profileRef} className={styles.tabContainer} >
          <div className="relative bg-white border smallCustomShadow rounded-lg p-6 flex flex-col gap-4">
            {/* Edit button */}
            <button
              onClick={() => openEditModal()}
              className="absolute top-4 right-4 p-2 hover:bg-gray-100 rounded-full border"
              title="Edit"
            >
              <FiEdit2 size={18} />
            </button> 

            {/* Info Grid */}
            <div className="grid grid-cols-2 gap-x-6 gap-y-2 mt-2">
              <div>
                <label className="text-xs text-gray-400">{t("USERS.MODAL.FIRST_NAME")}</label>
                <div className="flex items-center gap-2 font-semibold">
                  <FiUser size={16} />
                  {user.firstName}
                </div>
              </div>
              <div>
                <label className="text-xs text-gray-400">{t("USERS.MODAL.LAST_NAME")}</label>
                <div className="flex items-center gap-2 font-semibold">
                  <FiUser size={16} />
                  {user.lastName}
                </div>
              </div>
              <div>
                <label className="text-xs text-gray-400">{t("USERS.MODAL.EMAIL")}</label>
                <div className="flex items-center gap-2 font-semibold">
                  <FiMail size={16} />
                  {user.email}
                </div>
              </div>
              <div>
                <label className="text-xs text-gray-400">{t("USERS.MODAL.ROLE")}</label>
                <div className="flex items-center gap-2 font-semibold">
                  <FiFolder size={16} />
                  {user.roles && user.roles[0] && user.roles[0].name}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div ref={savedRef} className={styles.tabContainer} >
          {/* <div className="mt-6"> 
            {console.log(userTasks)}
            {loadingTasks ? (
              <div className="text-sm text-gray-400">{t('Chargement des tâches...')}</div>
            ) : userTasks.length === 0 ? (
              <div className="text-sm text-gray-400">{t('Aucune tâche trouvée pour vos projets')}</div>
            ) : (
              <div className="grid grid-cols-1 gap-2">
                {userTasks.map((task) => (
                  <MyPerformanceTaskContainer key={task.id} task={task} openTaskModal={openTaskModal} />
                ))}
              </div>
            )}
          </div> */}
          <div className='grid grid-cols-3 gap-x-2' >
            {tasksTest.map((task) => (
              <MyPerformanceTaskContainer key={task.id} task={task} openTaskModal={openTaskModal} />
            ))}
          </div>
        </div>
      </div>
      <AnimatePresence>
        {
          isTaskModalOpen &&
          <SideModal isOpen={isTaskModalOpen} title="side modal" close={closeTaskModal} >
            <TaskModal close={closeTaskModal} task={taskData} />
          </SideModal>
        }
      </AnimatePresence>
      <Modal isOpen={isEditModalOpen} close={closeEditModal} title={t("ACCOUNT.INFORMATIONS_TITLE")} >
        <EditModal close={closeEditModal} />
      </Modal>
    </div>
  )
}
